<div class="row mb-4 mb-sm-10">
  <div class="col px-1">
    <div class="blog-post d-flex flex-column flex-sm-row">
      @if (image?.src) {
        <div class="position-relative flex-shrink-0 me-sm-4">
          <img class="blog-post__image" [src]="image?.src" [alt]="image?.alt" />
          <div
            class="blog-post__labels blog-post__labels--image position-absolute d-none d-sm-flex flex-wrap-reverse justify-content-end"
          >
            @for (label of labels; track label) {
              <wl-blog-label [text]="label"> </wl-blog-label>
            }
          </div>
        </div>
      }
      <div
        class="blog-post__content d-flex flex-column position-relative bg-white rounded mx-1 p-2 mx-sm-0 p-sm-0"
        [ngClass]="{ 'mt-n10 mt-sm-0': image?.src }"
      >
        <div>
          <p class="blog-post__title h3 lh-sm">{{ title }}</p>
        </div>
        <div class="flex-grow-1 flex-shrink-1">
          <p class="blog-post__description">
            {{ description }}
          </p>
        </div>
        <div class="d-flex align-items-baseline justify-content-between">
          <a
            class="flex-shrink-0 me-2"
            [href]="url"
            [attr.aria-label]="
              a11yReadMoreLabel?.value ? a11yReadMoreLabel?.value : null
            "
            *scText="readMoreLabel"
          ></a>
          <div
            class="blog-post__labels d-flex d-sm-none flex-wrap-reverse justify-content-end"
          >
            @for (label of labels; track label) {
              <wl-blog-label [text]="label"> </wl-blog-label>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
